import { useIsWidthUp } from '../utils';

export function useBusTourAddLabel(fullLabel) {
    const isSmallScreen = !useIsWidthUp('sm');
    return isSmallScreen ? 'NEW' : fullLabel;
}
